import { useContext } from "react";

import {
  ClientContextType,
  ClientContext,
} from "../contexts/Client/ClientContext";

export const useClients = (): ClientContextType => {
  const context = useContext(ClientContext);
  if (!context) {
    throw new Error("useClients must be used within a Provider");
  }
  return context;
};
